import AlertList from './AlertList';
import AlertCreate from './AlertCreate';
import AlertDetail from './AlertDetail';

const routes = [
  {
    index: true,
    element: <AlertList />,
  },
  {
    path: 'new',
    element: <AlertCreate />,
  },
  {
    path: ':id',
    element: <AlertDetail />,
  },
];

export default routes;
export { AlertList, AlertCreate, AlertDetail };
